import {
  Address,
  Provider,
  VAULT_FACTORY,
  getChainConstant,
  getContract,
} from 'nftx.js';
import { VaultFactory } from '@nftx/abi';

const computeVaultAddress = ({
  address,
  name,
  network,
  provider,
  symbol,
}: {
  address: Address;
  name: string;
  symbol: string;
  provider: Provider;
  network: number;
}) => {
  const contract = getContract({
    abi: VaultFactory,
    address: getChainConstant(VAULT_FACTORY, network),
    provider,
  });

  return contract.read.computeVaultAddress({
    args: [address, name, symbol],
  });
};

export default computeVaultAddress;
